// extracted by mini-css-extract-plugin
module.exports = {"reactMarkDown":"Markdown_reactMarkDown__2i5_I"};